import { useEffect, useMemo } from "react"
import classNames from "classnames"
import { useController } from "react-hook-form"
import { FieldOption } from "../../types/FieldOption"
import { FieldProps } from "../../types/FieldProps"
import { FormErrorText } from "../FormErrorText"
import { FormHelperText } from "../FormHelperText"
import { FormLabel } from "../FormLabel"

export interface RadioGroupProps extends FieldProps {
  options: FieldOption[]
  className?: string
}

export function RadioGroup(props: RadioGroupProps) {
  const {
    field,
    fieldState: { error },
  } = useController(props)

  const { options, helperText, label, name, className, optional } = props
  const defaultValue = useMemo(() => {
    return props.defaultValue
  }, [props.defaultValue])

  useEffect(() => {
    if (!field.value) {
      field.onChange(defaultValue)
    }
  }, [field, defaultValue])

  return (
    <div className={classNames("flex flex-col", className)}>
      <fieldset>
        <legend>
          {label || name}
          {!optional && <span className="text-red-500">*</span>}
        </legend>
        {helperText?.length ? (
          <FormHelperText className="pb-[var(--alias-padding-xxs)]">
            {helperText}
          </FormHelperText>
        ) : null}
        {options.map(({ value, label }, index) => (
          <div
            className="flex items-center py-[var(--component-radio-space-tight)]"
            key={String(value) + index}
          >
            <input
              type="radio"
              {...field}
              id={String(value)}
              value={value}
              defaultChecked={field.value === value}
            />
            <FormLabel className="pl-2" htmlFor={String(value)}>
              {label}
            </FormLabel>
          </div>
        ))}
        {error && (
          <FormErrorText className="pt-[var(--alias-padding-xxs)]">
            {error.message}
          </FormErrorText>
        )}
      </fieldset>
    </div>
  )
}
